// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

import {
  signInWithEmailAndPassword,
  signOut,
  createUserWithEmailAndPassword,
  getAuth,
  sendPasswordResetEmail,
} from "firebase/auth";

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDhPF8d5Ba8X2kMObVxVvhKdB-G8USxk-8",
  authDomain: "gym-assistant-75371.firebaseapp.com",
  projectId: "gym-assistant-75371",
  storageBucket: "gym-assistant-75371.appspot.com",
  messagingSenderId: "346984064814",
  appId: "1:346984064814:web:81774dff75f41b64fffcbf",
  databaseUrl: "https://gym-assistant-75371-default-rtdb.firebaseio.com/",
  measurementId: "G-1WFZLL2CDP",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const auth = getAuth();
const firestore = getFirestore();

export {
  auth,
  signInWithEmailAndPassword,
  signOut,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  firestore,
};
